import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
};

const SettingsDescription = ({ children, className }) => (
  <div className={clsx('text-gray-700 mb-2 font-normal', className)}>{children}</div>
);

SettingsDescription.propTypes = propTypes;

export default SettingsDescription;
